import { useMemo } from 'react'

import { useInfiniteQuery } from '@tanstack/react-query'

import { getAllDevices } from '@/lib/api/cluster'
import { Device } from '@/lib/types'

import useAuthStore from '@/hooks/stores/useAuthStore'

const useDevices = () => {
  const { accessToken, isDemo } = useAuthStore()

  const {
    isFetching,
    isFetchingNextPage,
    data: rawData,
    fetchNextPage
  } = useInfiniteQuery<{ devices: Device[]; total: number }>({
    queryKey: ['devices', isDemo],
    queryFn: ({ pageParam = 1 }) => getAllDevices({ page: pageParam }),
    keepPreviousData: true,
    getNextPageParam: (_lastPage, pages) => {
      return pages[0].total > 0 && pages[pages.length - 1].devices.length > 0
        ? pages.length + 1
        : undefined
    },
    enabled: !!accessToken || isDemo
  })

  const data = useMemo(() => {
    const devices = rawData?.pages?.map((page) => page.devices).flat() || []
    const totalDevices = rawData?.pages[0].total || 0

    return { devices, totalDevices }
  }, [rawData])

  const showEmptyList = !isFetching && !data.totalDevices

  return { isFetching, isFetchingNextPage, data, fetchNextPage, showEmptyList }
}

export default useDevices
